import type { ja } from './lang-ja';
import { LangComEn } from '@/locales/lang-com-en';
export const en: typeof ja = {
  com: LangComEn,
  seo: {
    title: 'INSPIRE LLC > About us',
    description: `[INSPIRE LLC] Professional Guild of the Automotive Distribution Industry`,
    keywords: `INSPIRE LLC,cars,Automobile,export, trade ,Used Car,vehicle,tokyo,Japan,Professional Guild,DAO,application development,`,
  },
  row1: {
    title: 'Professional Guild',
    m1: 'A professional guild is an organization where professionals with various expertise collaborate to address social issues and create new value.',
    m2: 'INSPIRE LLC is a professional guild specialized in the automotive distribution industry.',
    m3: '',
  },
  row2: {
    title: 'Decentralized Autonomous Organization',
    m1: 'DAO stands for [Decentralized Autonomous Organization].',
    m2: 'It views an organization as a network, parallelizing decision-making and realizing operations that do not depend on a specific manager or central organization.',
    m3: 'INSPIRE LLC is a DAO that allows professionals in each field to influence each other and be creative while increasing organizational flexibility.',
  },
  row3: {
    title: 'Company outline',
    left: {
      CompanyName: 'Company name',
      HeadOffice: 'Head office',
      YearEstablished: 'Year established',
      Ceo: 'President & CEO',
      Tel: 'TEL',
      FAX: 'FAX',
      EMail: 'E-mail',
      OpenHours: 'Open hours',
      HolidaySat: 'HolidaySat',
      Business: 'Business',
    },
    right: {
      CompanyName: 'INSPIRE LLC',
      HeadOffice: '3-11-7 Higashi-tateishi Katsushika-ku Tokyo-to 124-0013 JAPAN',
      YearEstablished: 'Sep 2009',
      Ceo: 'Kazumasa “Joe” Tajima',
      EMail: 'sales@inspire-llc.jp',
      OpenHours: '10:00-19:00',
      HolidaySat: 'Sat, Sun',
      Business: 'Brand new, used vehicle trading business',
    },
  },
};
